import React from 'react'
import { Popover, Button } from 'element-react'

const PopoverSG = () => {
    return (
        <div>
            <Popover
                placement="top-start"
                title="Title"
                width="200"
                trigger="hover"
                content="This is content, this is content, this is content"
            >
                <Button type="primary" className="margin-right-small">
                    Hover to activate
                </Button>
            </Popover>
            <Popover
                placement="bottom"
                title="Title"
                width="200"
                trigger="click"
                content="This is content, this is content, this is content"
            >
                <Button type="primary" className="margin-right-small">
                    Click to activate
                </Button>
            </Popover>
            <Popover
                placement="right"
                title="Title"
                width="200"
                trigger="focus"
                content="This is content, this is content, this is content"
            >
                <Button type="primary" className="margin-right-small">
                    Focus to activate
                </Button>
            </Popover>
        </div>
    )
}

export default PopoverSG
